<template>
  <div>
    <van-popup
      v-model="innerVisible"
      round
      closeable
      class="location-dialog"
      :style="{ width: '290px' }"
      @closed="handleClosed"
    >
      <div class="dialog-shell">
        <div class="dialog-title">投放点定位</div>

        <van-button
          class="dialog-locate-button"
          type="info"
          :disabled="!editable"
          @click="openMapPage"
        >
          开始定位
        </van-button>

        <div class="result-divider">
          <span></span>
          <em>定位结果</em>
          <span></span>
        </div>

        <div class="result-box">
          <div class="result-row">
            <span>经度：</span>
            <strong>{{ currentLocation.longitude || '-' }}</strong>
          </div>
          <div class="result-row">
            <span>纬度：</span>
            <strong>{{ currentLocation.latitude || '-' }}</strong>
          </div>
        </div>

        <van-button
          class="dialog-confirm-button"
          block
          type="info"
          :disabled="!editable"
          @click="save"
        >
          确认
        </van-button>
      </div>
    </van-popup>

    <div v-show="mapPageVisible" class="map-page">
      <div class="map-nav">
        <button type="button" class="map-back" @click="closeMapPage">返回</button>
        <div class="map-title">投点一定位</div>
      </div>
      <div :id="mapId" class="map-container">
        <div v-if="!mapReady" class="map-placeholder">地图加载中</div>
      </div>
      <div class="map-content">
        <div class="map-section-title">当前位置</div>
        <div class="coord-box">
          <div class="coord-row">
            <span>经度</span>
            <strong>{{ currentLocation.longitude || '-' }}</strong>
          </div>
          <div class="coord-row">
            <span>纬度</span>
            <strong>{{ currentLocation.latitude || '-' }}</strong>
          </div>
        </div>
        <div class="map-actions">
          <van-button type="info" :loading="locating" :disabled="!editable" @click="locate">
            开始定位
          </van-button>
          <van-button type="info" :disabled="!editable" @click="submitFromMap">
            提交
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify } from 'vant'

export default {
  name: 'LocationSignInDrawer',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    groups: {
      type: Array,
      default: () => []
    },
    signIns: {
      type: Array,
      default: () => []
    },
    targetGroup: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerVisible: false,
      mapPageVisible: false,
      selectedGroupId: null,
      localSignIns: [],
      locating: false,
      map: null,
      marker: null,
      accuracyCircle: null,
      geolocation: null,
      mapReady: false,
      mapId: 'location-map-' + Math.random().toString(36).slice(2),
      currentLocation: this.emptyLocation()
    }
  },
  computed: {
    selectedGroupName() {
      const group = this.groups.find(item => String(item.id) === String(this.selectedGroupId))
      return group ? group.classifyName : ''
    }
  },
  watch: {
    value(val) {
      this.innerVisible = val
      if (val) {
        this.open()
      }
    },
    innerVisible(val) {
      this.$emit('input', val)
    },
    signIns: {
      deep: true,
      handler(val) {
        this.localSignIns = (val || []).map(item => Object.assign({}, item))
      }
    }
  },
  mounted() {
    this.innerVisible = this.value
  },
  methods: {
    emptyLocation() {
      return {
        location: '',
        longitude: '',
        latitude: '',
        accuracy: '',
        locationType: ''
      }
    },
    open() {
      this.localSignIns = (this.signIns || []).map(item => Object.assign({}, item))
      const targetGroup = this.groups.find(group => this.targetGroup && String(group.id) === String(this.targetGroup.id))
      const firstUnsigned = this.groups.find(group => !this.hasSigned(group))
      const firstGroup = targetGroup || firstUnsigned || this.groups[0]
      if (firstGroup) {
        this.selectGroup(firstGroup)
      }
    },
    handleClosed() {
      this.locating = false
    },
    selectGroup(group) {
      this.selectedGroupId = group.id
      const signed = this.localSignIns.find(item => String(item.groupId) === String(group.id))
      this.currentLocation = signed ? Object.assign({}, this.emptyLocation(), signed) : this.emptyLocation()
    },
    hasSigned(group) {
      return this.localSignIns.some(item => String(item.groupId) === String(group.id) && item.location)
    },
    openMapPage() {
      if (!this.editable) {
        Notify({ type: 'warning', message: '当前状态不可修改' })
        return
      }
      this.innerVisible = false
      this.mapPageVisible = true
      this.$nextTick(() => {
        this.initMap()
        this.resizeMap()
        this.locate()
      })
    },
    closeMapPage() {
      this.mapPageVisible = false
      this.innerVisible = true
    },
    initMap() {
      const AMap = window.AMap
      if (!AMap) {
        this.mapReady = false
        return
      }
      if (this.map) {
        this.mapReady = true
        if (this.map.resize) {
          this.map.resize()
        }
        return
      }
      this.map = new AMap.Map(this.mapId, {
        center: [121.480033, 31.236232],
        resizeEnable: true,
        zoom: 11
      })
      this.map.plugin(['AMap.ToolBar'], () => {
        this.map.addControl(new AMap.ToolBar({
          position: 'LT',
          liteStyle: false
        }))
      })
      this.mapReady = true
    },
    resizeMap() {
      window.setTimeout(() => {
        if (this.map && this.map.resize) {
          this.map.resize()
        }
      }, 60)
    },
    locate() {
      const AMap = window.AMap
      if (!AMap) {
        Notify({ type: 'danger', message: '地图加载失败' })
        return
      }
      if (!this.map) {
        this.initMap()
      }
      if (!this.map) {
        this.locating = false
        return
      }
      this.locating = true
      AMap.plugin('AMap.Geolocation', () => {
        if (!this.geolocation) {
          this.geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 10000,
            buttonOffset: new AMap.Pixel(10, 20),
            zoomToAccuracy: true,
            buttonPosition: 'RB'
          })
          this.map.addControl(this.geolocation)
          AMap.event.addListener(this.geolocation, 'complete', data => this.handleLocationComplete(data))
          AMap.event.addListener(this.geolocation, 'error', data => this.handleLocationError(data))
        }
        this.geolocation.getCurrentPosition()
      })
    },
    handleLocationComplete(result) {
      this.locating = false
      if (!result || !result.position) {
        Notify({ type: 'danger', message: '定位失败' })
        return
      }
      const longitude = result.position.lng || result.position.getLng()
      const latitude = result.position.lat || result.position.getLat()
      const accuracy = result.accuracy ? Math.round(result.accuracy) : ''
      const locationType = result.location_type || ''
      this.currentLocation = {
        longitude,
        latitude,
        accuracy,
        locationType,
        location: longitude + ',' + latitude
      }
      if (locationType === 'ip') {
        Notify({ type: 'warning', message: '当前为IP定位，精度较低，请开启浏览器定位权限后重新定位' })
      }
    },
    handleLocationError(result) {
      this.locating = false
      Notify({
        type: 'danger',
        message: this.formatLocationError(result)
      })
    },
    formatLocationError(result) {
      const message = result && (result.message || result.info)
      if (message) {
        return '定位失败：' + message
      }
      return '定位失败，请检查浏览器定位权限，并使用 localhost 或 HTTPS 访问'
    },
    renderMarker(longitude, latitude, accuracy) {
      const AMap = window.AMap
      if (!this.map || !longitude || !latitude) {
        return
      }
      const position = [longitude, latitude]
      const radius = Number(accuracy) || 80
      if (!this.accuracyCircle) {
        this.accuracyCircle = new AMap.Circle({
          center: position,
          radius,
          strokeColor: '#3f63f4',
          strokeOpacity: 0.35,
          strokeWeight: 1,
          fillColor: '#3f63f4',
          fillOpacity: 0.12
        })
        this.accuracyCircle.setMap(this.map)
      } else {
        this.accuracyCircle.setCenter(position)
        this.accuracyCircle.setRadius(radius)
      }
      if (!this.marker) {
        this.marker = new AMap.CircleMarker({
          center: position,
          radius: 7,
          strokeColor: '#ffffff',
          strokeWeight: 3,
          strokeOpacity: 1,
          fillColor: '#3f63f4',
          fillOpacity: 1,
          zIndex: 20
        })
        this.marker.setMap(this.map)
      } else {
        this.marker.setCenter(position)
      }
      this.map.setZoomAndCenter(13, position)
    },
    submitFromMap() {
      if (!this.currentLocation.location) {
        Notify({ type: 'warning', message: '请先完成定位' })
        return
      }
      this.save(false)
      this.mapPageVisible = false
    },
    save(closeDialog = true) {
      if (!this.editable) {
        Notify({ type: 'warning', message: '当前状态不可修改' })
        return
      }
      if (!this.selectedGroupId || !this.currentLocation.location) {
        Notify({ type: 'warning', message: '请先完成定位' })
        return
      }
      const next = this.localSignIns.filter(item => String(item.groupId) !== String(this.selectedGroupId))
      next.push({
        groupId: this.selectedGroupId,
        groupName: this.selectedGroupName,
        location: this.currentLocation.location,
        longitude: this.currentLocation.longitude,
        latitude: this.currentLocation.latitude,
        accuracy: this.currentLocation.accuracy,
        locationType: this.currentLocation.locationType,
        address: ''
      })
      this.localSignIns = next
      this.$emit('save', this.localSignIns)
      if (closeDialog) {
        this.innerVisible = false
      }
      Notify({ type: 'success', message: '定位已确认' })
    }
  }
}
</script>

<style lang="less" scoped>
.location-dialog {
  overflow: hidden;
}

.dialog-shell {
  padding: 22PX 24PX 18PX;
  background: #ffffff;
  text-align: center;
}

.dialog-title {
  color: #333333;
  font-size: 18PX;
  font-weight: 700;
  line-height: 24PX;
}

.dialog-locate-button {
  width: 156PX;
  height: 42PX;
  margin-top: 22PX;
  border-radius: 4PX;
  font-size: 15PX;
  background: #3158f5;
  border-color: #3158f5;
}

.result-divider {
  display: flex;
  align-items: center;
  gap: 10PX;
  margin: 24PX 0 14PX;
}

.result-divider span {
  flex: 1;
  height: 1PX;
  background: #e5e6eb;
}

.result-divider em {
  color: #999999;
  font-size: 15PX;
  font-style: normal;
  white-space: nowrap;
}

.result-box {
  width: 172PX;
  margin: 0 auto;
  text-align: left;
}

.result-row {
  display: flex;
  align-items: center;
  min-height: 34PX;
  color: #333333;
  font-size: 15PX;
  line-height: 22PX;
}

.result-row span {
  font-weight: 700;
}

.result-row strong {
  flex: 1;
  font-weight: 700;
  word-break: break-all;
}

.dialog-confirm-button {
  height: 42PX;
  margin-top: 18PX;
  border-radius: 4PX;
  font-size: 15PX;
  background: #3158f5;
  border-color: #3158f5;
}

.map-page {
  position: fixed;
  z-index: 3000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
}

.map-nav {
  height: 46PX;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #ffffff;
  background: #3158f5;
}

.map-back {
  position: absolute;
  left: 12PX;
  top: 0;
  height: 46PX;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14PX;
}

.map-title {
  font-size: 17PX;
  font-weight: 700;
}

.map-container {
  position: relative;
  width: 100%;
  height: 240PX;
  background: #eef2f8;
}

.map-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #86909c;
  font-size: 14PX;
}

.map-content {
  padding: 18PX 32PX;
  background: #ffffff;
}

.map-section-title {
  color: #999999;
  font-size: 16PX;
  line-height: 24PX;
  margin-bottom: 14PX;
}

.coord-box {
  margin-bottom: 22PX;
}

.coord-row {
  display: flex;
  align-items: center;
  min-height: 28PX;
  color: #333333;
  font-size: 14PX;
}

.coord-row span {
  width: 48PX;
  color: #666666;
}

.coord-row strong {
  flex: 1;
  font-weight: 500;
  word-break: break-all;
}

.map-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32PX;
}

.map-actions .van-button {
  height: 38PX;
  border-radius: 4PX;
  background: #3158f5;
  border-color: #3158f5;
  font-size: 14PX;
}
</style>
